import { useTranslation } from 'react-i18next';

/**
 * @graph-stack line-user-id-resolver
 * @graph-domain Engineering
 * @graph-business フルスクリーンローディング画面。ガラスモーフィズム背景にグラデーションアクセントスピナーと「LINE User ID Resolver」テキストを表示
 * @graph-connects none
 */
export function LoadingScreen() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[var(--color-bg-base)] flex items-center justify-center">
      {/* 装飾用グラデーションオーブ */}
      <div
        className="gradient-orb gradient-orb-primary"
        style={{ width: 300, height: 300, top: '20%', left: '10%' }}
      />
      <div
        className="gradient-orb gradient-orb-success"
        style={{ width: 200, height: 200, bottom: '20%', right: '15%' }}
      />

      <div className="relative glass-card p-12 flex flex-col items-center gap-6 animate-fade-in">
        {/* グラデーションスピナー */}
        <div className="relative w-12 h-12">
          <div className="absolute inset-0 rounded-full border-3 border-[var(--color-border)]" />
          <div
            className="absolute inset-0 rounded-full border-3 border-transparent animate-spin"
            style={{
              borderTopColor: 'var(--color-accent-primary)',
              borderRightColor: 'transparent',
              borderBottomColor: 'transparent',
              borderLeftColor: 'transparent',
            }}
          />
        </div>

        {/* タイトル */}
        <div className="text-center">
          <h1 className="gradient-text text-xl font-bold">{t('app.name')}</h1>
          <p className="mt-2 text-sm text-[var(--color-text-muted)] animate-pulse">
            {t('common.loading')}
          </p>
        </div>
      </div>
    </div>
  );
}
